import React, { useState, useEffect } from 'react';
import VisorPDF from '../Compras/Reportes/visorPDF';
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
} from "@react-pdf/renderer";

import {formatSoles } from '../../Global';



const Estilos = StyleSheet.create({
    page: {
        fontSize: 10,
        paddingTop: 30,
        paddingBottom: 30,
        paddingLeft: 30,
        paddingRight: 30,
    },
    header: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: 5,
        borderColor: "#bfbfbf",
        borderWidth: 1,
        height: "10%"

    },
    emp_logo: {
        display: "flex",
        flexDirection: "column",
        borderColor: "#bfbfbf",
        borderWidth: 0,
        width: "20%",
        padding: 5
    },
    emp_info: {
        display: "flex",
        width: "79%",
        padding: 10,
        flexDirection: "col",
        borderColor: "#bfbfbf",
        borderWidth: 1,
        textAlign: "center",
    },
    emp_info_title: {
        fontSize: "14",
        fontWeight: "800",
        borderWidth: 0,
        margin: 5
    },
    emp_info_detalle: {
        fontSize: "7",
        margin: 1
        // fontWeight:"800",
    },
    body: {
        padding: 5,
        borderColor: "#bfbfbf",
        borderWidth: 0,
        marginTop: 5,
        height: "70%"
    },
    fluidBody: {
        padding: 5,
        borderColor: "#bfbfbf",
        borderWidth: 0,
        marginTop: 5,
    },
    body_prov: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        borderColor: "#bfbfbf",
        // width:"100%"
    },
    body_prov_info: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: 3,
        width: "80%",
        borderWidth: 1,
        borderColor: "#bfbfbf",
    },
    body_prov_info_c1: {
        display: "flex",
        flexDirection: "column",
        width: "60%",
    },
    body_prov_info_c2: {
        display: "flex",
        flexDirection: "column",
        width: "39%",
    },
    body_prov_oc: {
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",
        padding: 3,
        width: "20%",
        borderWidth: 1,
        borderColor: "#bfbfbf",
    },
    cell_etiqueta: {
        fontSize: 9,
        marginBottom: 2,
        fontWeight: "900",
        color: "#bfbfbf",
    },
    cell: {
        marginBottom: 2,
        color: "#58595d",
        fontSize: 9
    },

    body_oc: {
        // display: "flex",
        // flexDirection: "row",
        justifyContent: "space-between",
        borderColor: "#bfbfbf",
        // width:"100%"
    },
    body_oc_info: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: 3,
        width: "100%",
        borderWidth: 1,
        borderColor: "#bfbfbf",
        marginTop: 5
    },
    body_oc_info_c1: {
        width: "35%",
    },
    body_oc_info_c2: {
        width: "35%",
    },
    body_oc_info_c3: {
        width: "30%",
    },

    body_detalle: {
        justifyContent: "space-between",
        borderColor: "#bfbfbf",
        borderWidth: 0,
        marginTop: 5
    },


    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,

    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableColHeader: {
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        backgroundColor: "#f0f0f0"
    },
    tableCol: {
        borderStyle: "solid",
        borderColor: '#bfbfbf',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCellHeader: {
        margin: "auto",
        margin: 5,
        color: "#58595d",
        // fontSize: 12,
        fontWeight: 500,
    },
    tableCell: {
        margin: "auto",
        margin: 5,
        color: "#58595d",
        fontSize: 9,
    },


    footer: {
        display: "flex",
        flexDirection: "column",
        padding: 5,
        borderColor: "#bfbfbf",
        borderWidth: 1,
        marginTop: 5,
        height: "20%"

    },

    footer_seccion_1: {
        display: "flex",
        flexDirection: "column",

    },
    footer_seccion_2: {
        display: "flex",
        flexDirection: "row",
        // alignContent:"space-between",
        justifyContent: "space-between",
        // alignItems: "center",
        // border: 1,
        // borderBottom: 1,
        padding: 5
    },
    footer_seccion_2_seccion: {
        textAlign: "center",
        borderColor: "#bfbfbf",
        borderWidth: 1,
        fontSize: 8,
        width: "32%",
        height: 90,
        padding: 3
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 10,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },

});

export default function DetailPDF({ currentId }) {
    const [compraExterna, setCompraExterna] = useState(null);
    const [proveedor, setProveedor] = useState(null);
    const [detalles, setDetalles] = useState([]);
    const [total, setTotal] = useState(0);
    let urlImage = null;

    useEffect(() => {
        fetchCompraExterna();
        fetchDetalles();
    }, [currentId]);

    useEffect(() => {
        if (!compraExterna) return;

        fetchProveedor(compraExterna.IdProveedor);
    }, [compraExterna]);

    const fetchCompraExterna = async () => {
        try {
            const response = await fetch(`/api/comprasexternas/items/${currentId}`);

            if (!response.ok) {
                throw new Error('Failed to fetch compra externa');
            }

            const data = await response.json();
            setCompraExterna(data[1][0]);

            urlImage = `${process.env.REACT_APP_FACT_BASE_URL}/datos/${data[1][0].RucEmpresa}/Img/logo_${data[1][0].RucEmpresa}.png`;
        } catch (error) {
            console.error('Error fetching compra externa:', error);
        }
    }

    const fetchDetalles = async () => {
        try {
            const response = await fetch(`/api/comprasexternas/items/${currentId}/detalles`);

            if (!response.ok) {
                throw new Error('Failed to fetch detalles');
            }

            const data = await response.json();
            setDetalles(data[1]);
            setTotal(data[1].reduce((acc, item) => acc + item.Importe, 0));
        } catch (error) {
            console.error('Error fetching detalles:', error);
        }
    }

    const fetchProveedor = async (idProveedor) => {
        try {
            const response = await fetch(`/api/proveedores/item/${idProveedor}`);

            if (!response.ok) {
                throw new Error('Failed to fetch proveedor');
            }

            const data = await response.json();
            setProveedor(data[0][0]);
        } catch (error) {
            console.error('Error fetching proveedor:', error);
        }
    }

    if (!compraExterna || !proveedor) return null;

    return (
        <div>
            <VisorPDF fileName={`${compraExterna.Numero}.pdf`}>
                <Document>
                    <Page style={Estilos.page}>
                        <View style={Estilos.header}>
                            <View style={Estilos.emp_logo}>
                                {urlImage && <Image src={urlImage}/>}
                            </View>
                            <View style={Estilos.emp_info}>
                                <Text
                                    style={Estilos.emp_info_title}>{`Compra externa N° ${compraExterna.Numero}`}</Text>
                                <Text
                                    style={Estilos.emp_info_detalle}>{`Principal:  ${compraExterna.NombreEmpresa} :: ${compraExterna.DireccionEmpresa}`}</Text>
                                <Text
                                    style={Estilos.emp_info_detalle}>{`Sucursal:  ${compraExterna.NombreSucursal} :: ${compraExterna.DireccionSucursal}`}</Text>
                            </View>
                        </View>
                        <View style={Estilos.body}>
                            <View style={{marginTop: 5}}><Text>Datos Generales</Text></View>
                            <View style={Estilos.body_oc}>
                                <View style={Estilos.body_oc_info}>
                                    <View style={Estilos.body_oc_info_c1}>
                                        <Text style={Estilos.cell_etiqueta}>Fecha Movimiento:</Text>
                                        <Text style={Estilos.cell}>{new Date(compraExterna.FechaMovimiento).toLocaleDateString('es-PE')}</Text>
                                        <Text style={Estilos.cell_etiqueta}>Documento Asociado:</Text>
                                        <Text style={Estilos.cell}>{compraExterna.NomTipoDocumentoSunat}</Text>
                                    </View>
                                    <View style={Estilos.body_oc_info_c2}>
                                        <Text style={Estilos.cell_etiqueta}>Tipo Movimiento:</Text>
                                        <Text style={Estilos.cell}>Compra Externa</Text>
                                        <Text style={Estilos.cell_etiqueta}>Nro Documento:</Text>
                                        <Text style={Estilos.cell}>{compraExterna.NroDocumentoSunat}</Text>
                                    </View>
                                </View>
                            </View>
                            <View style={{marginTop: 5}}><Text>Detalle</Text></View>
                            <View style={Estilos.body_detalle}>
                                <View style={Estilos.table}>
                                    <View style={Estilos.tableRow}>
                                        <View style={[Estilos.tableColHeader, {width: "4%", textAlign: "center"}]}>
                                            <Text style={Estilos.tableCellHeader}>N°</Text>
                                        </View>
                                        <View style={[Estilos.tableColHeader, {width: "60%", textAlign: "left"}]}>
                                            <Text style={Estilos.tableCellHeader}>Descripción</Text>
                                        </View>
                                        <View style={[Estilos.tableColHeader, {width: "12%", textAlign: "center"}]}>
                                            <Text style={Estilos.tableCellHeader}>Cantidad</Text>
                                        </View>
                                        <View style={[Estilos.tableColHeader, {width: "12%", textAlign: "center"}]}>
                                            <Text style={Estilos.tableCellHeader}>P.U.</Text>
                                        </View>
                                        <View style={[Estilos.tableColHeader, {width: "12%", textAlign: "left"}]}>
                                            <Text style={Estilos.tableCellHeader}>Importe</Text>
                                        </View>
                                    </View>
                                    {
                                        detalles.map((item) => {
                                            return (
                                                <View key={item.Correlativo} style={Estilos.tableRow}>
                                                    <View style={[Estilos.tableCol, {width: "4%"}]}>
                                                        <Text
                                                            style={[Estilos.tableCell, {textAlign: "center"}]}>{item.Correlativo}</Text>
                                                    </View>
                                                    <View style={[Estilos.tableCol, {width: "60%"}]}>
                                                        <Text
                                                            style={[Estilos.tableCell, {textAlign: "left"}]}>{item.Descripcion}</Text>
                                                    </View>
                                                    <View style={[Estilos.tableCol, {width: "12%"}]}>
                                                        <Text
                                                            style={[Estilos.tableCell, {textAlign: "right"}]}>{item.Cantidad}</Text>
                                                    </View>
                                                    <View style={[Estilos.tableCol, {width: "12%"}]}>
                                                        <Text
                                                            style={[Estilos.tableCell, {textAlign: "right"}]}>S/ {formatSoles(item.Precio)}</Text>
                                                    </View>
                                                    <View style={[Estilos.tableCol, {width: "12%"}]}>
                                                        <Text
                                                            style={[Estilos.tableCell, {textAlign: "left"}]}>S/ {formatSoles(item.Importe)}</Text>
                                                    </View>
                                                </View>
                                            )
                                        })
                                    }
                                    <View style={Estilos.tableRow}>
                                        <View style={[Estilos.tableCol, {width: "100%", }]}>
                                            <Text style={[Estilos.tableCell, {textAlign: "right"}]}>Importe Total: S/ {formatSoles(total)}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>

                        <Text style={Estilos.pageNumber} render={({pageNumber, totalPages}) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed/>
                    </Page>
                </Document>
            </VisorPDF>
        </div>
    )
}